import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import App from './App.jsx'
import { setDeferredPrompt } from './lib/installPrompt'

// Capture the install prompt so components can trigger it later
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  setDeferredPrompt(e)
})

// Clear prompt state once the app is installed
window.addEventListener('appinstalled', () => {
  setDeferredPrompt(null)
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('SW registration failed:', err))
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
